import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from 'src/app/shared/session';

@Injectable({
  providedIn: 'root'
})
export class NivelAccesoService {

  constructor(private dataService: DataService) { }

  private listarNivelAccesoUrl: string = 'nivelAcceso/listar';
  private listarNivelAccesoPorUrl: string = 'nivelAcceso/listarPor';

  listarNivelAcceso(): any {
    this.dataService.set(this.listarNivelAccesoUrl);
    return this.dataService.execGetJson();
  }

  listarNivelAccesoPor(userName: string, idEmpresa: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("userName", userName);
    parameters = parameters.append("idEmpresa", String(idEmpresa));
    this.dataService.set(this.listarNivelAccesoPorUrl);
    return this.dataService.execGetJson(parameters);
  }
}
